import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyRound, Loader2, UserCog } from 'lucide-react';
import { toast } from 'sonner';

import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function AccountPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirmation: '' });
  const [saving, setSaving] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (form.new_password !== form.confirmation) {
      toast.error('Konfirmasi password tidak sama.');
      return;
    }
    setSaving(true);
    try {
      await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success('Password berhasil diubah. Silakan login kembali.');
      logout();
      navigate('/login', { replace: true });
    } catch (error) {
      toast.error(error?.response?.data?.detail || 'Password gagal diubah.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="animate-in-up max-w-2xl">
      <div className="mb-6">
        <h1 className="text-3xl font-semibold tracking-tight flex items-center gap-2">
          <UserCog className="w-6 h-6 text-[var(--fpccs-primary)]" /> Akun Saya
        </h1>
        <p className="text-sm text-muted-fpccs mt-1">{user?.name} · {user?.email} · {user?.role}</p>
      </div>

      <form onSubmit={submit} className="card-fpccs p-5 space-y-4">
        <div className="flex items-center gap-2 font-medium"><KeyRound className="w-4 h-4" /> Ganti Password</div>
        <p className="text-xs text-muted-fpccs">Minimal 12 karakter dan gunakan sedikitnya tiga jenis karakter: huruf kecil, huruf besar, angka, atau simbol.</p>
        <PasswordField label="Password saat ini" value={form.current_password} onChange={(value) => setForm((old) => ({ ...old, current_password: value }))} />
        <PasswordField label="Password baru" value={form.new_password} onChange={(value) => setForm((old) => ({ ...old, new_password: value }))} />
        <PasswordField label="Ulangi password baru" value={form.confirmation} onChange={(value) => setForm((old) => ({ ...old, confirmation: value }))} />
        <Button type="submit" disabled={saving} className="bg-[var(--fpccs-primary)] text-[var(--fpccs-bg)] hover:bg-[var(--fpccs-primary-2)]">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Simpan Password'}
        </Button>
      </form>
    </div>
  );
}

function PasswordField({ label, value, onChange }) {
  return <div className="space-y-1.5"><Label className="text-xs text-muted-fpccs">{label}</Label><Input type="password" required minLength={12} maxLength={128} autoComplete="new-password" value={value} onChange={(event) => onChange(event.target.value)} /></div>;
}
